interface ArrowDownIconeProps {
  color?: string;
  width?: string;
  height?: string;
}

export const ArrowDownIcone = ({ width = '18', height = '29', color ='#942000' }: ArrowDownIconeProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.875 28.1719C9.38281 28.6641 8.5625 28.6641 8.07031 28.1719L1.01562 21.5547C0.523438 21.0625 0.25 20.4062 0.25 19.6953C0.25 18.2734 1.34375 17.125 2.76562 17.125H4.625V3.5625C4.625 1.92188 5.99219 0.5 7.6875 0.5H10.3125C11.9531 0.5 13.375 1.92188 13.375 3.5625V17.125H15.1797C16.6016 17.125 17.75 18.2734 17.75 19.6953C17.75 20.4062 17.4219 21.0625 16.9297 21.5L9.875 28.1719ZM14.9609 19.75H12.0625C11.2969 19.75 10.75 19.2031 10.75 18.4375V3.5625C10.75 3.34375 10.5312 3.125 10.3125 3.125H7.6875C7.41406 3.125 7.25 3.34375 7.25 3.5625V18.4375C7.25 8.8203 7.08594 19.1484 6.86719 19.3672C6.59375 19.6406 6.26562 19.75 5.9375 19.75H2.98438L9 25.3828L14.9609 19.75Z'
        fill={`${color}`}
      />
    </svg>
  );
};
